'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdCardMembership = function MdCardMembership(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.4 16.6v-10h-26.8v10h26.8z m0 8.4v-3.4h-26.8v3.4h26.8z m0-21.6c1.8 0 3.2 1.4 3.2 3.2v18.4c0 1.9-1.4 3.4-3.2 3.4h-6.8v8.2l-6.6-3.2-6.6 3.2v-8.2h-6.8c-1.8 0-3.2-1.5-3.2-3.4v-18.4c0-1.8 1.4-3.2 3.2-3.2h26.8z' })
        )
    );
};

exports.default = MdCardMembership;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/card-membership.js
// module id = 1289
// module chunks = 168707334958949